import React from 'react';
import { WidgetConfig } from '../../types';
import getResource from '../../helpers/get-resource';
import getField from '../../helpers/get-field';

import CreateAWidgetPreviewMessage from '../../create-a-widget/components/create-a-widget-preview-message';
import useResourceSparkLineComparison from '../../../section-dashboard/hooks/widget-comparison/use-resource-spark-line-comparison';
import useResourceComparison from '../../../section-dashboard/hooks/widget-comparison/use-resource-comparison';
import useResourceTotalComparison from '../../../section-dashboard/hooks/widget-comparison/use-resource-total-comparison';
import { WidgetColour } from '../../../section-dashboard/types';
import WidgetSparkLineComparison from '../../../section-dashboard/widgets/widget-comparison/widget-spark-line-comparison';

const WidgetPreviewSparklineComparison = ({ config }: { config: WidgetConfig }) => {
    // Get the request values from the widget
    const resource = getResource(config.resource);
    const graphMetricField = config.graph_metrics && getField(config.graph_metrics);
    const widgetColor = config.widget_color;

    const resourceData = useResourceComparison({
        resource: resource,
        request: {
            isGraph: true,
            orderBy: resource ? [{ field: resource?.dateDimension, orderByDirection: 'asc' }] : [],
            groupBy: resource?.dateDimension,
            graphGroupBy: resource ? [resource?.dateDimension] : [],
            graphMetrics: graphMetricField ? [graphMetricField] : [],
            enabled: !!resource,
        },
    });

    const sparklineData = useResourceSparkLineComparison({
        resourceData: resourceData,
        metric: graphMetricField || undefined,
        dateDimension: resource?.dateDimension,
    });

    const resourceTotalData = useResourceComparison({
        resource: resource,
        request: {
            orderBy: resource ? [{ field: resource?.dateDimension, orderByDirection: 'asc' }] : [],
            groupBy: resource?.dateDimension,
            totals: true,
            enabled: !!resource,
        },
    });

    const totalData = useResourceTotalComparison({
        resourceData: resourceTotalData,
    });

    if (config.graph_metrics && config.graph_metrics.length > 0) {
        return (
            <WidgetSparkLineComparison
                title={config.widget.title}
                data={sparklineData}
                totalData={totalData}
                colour={WidgetColour[widgetColor as keyof typeof WidgetColour]}
            />
        );
    }

    return <CreateAWidgetPreviewMessage message="Please select a metric to preview the sparkline graph" />;
};

export default WidgetPreviewSparklineComparison;
